export const GET_ALL_ONBOARDING_TIPS = "GET_ALL_ONBOARDING_TIPS";
export const CREATE_NEW_ONBOARDING = "CREATE_NEW_ONBOARDING";
export const UPDATE_ONBOARDING = "UPDATE_ONBOARDING";
export const DELETE_ONBOARDING = "DELETE_ONBOARDING";
